'use client';

import { cn } from '../../utils/cn';

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export function Label({ 
  children, 
  className,
  ...props 
}: LabelProps) {
  return (
    <label
      className={cn(
        'text-sm font-medium text-zinc-700',
        className
      )}
      {...props}
    >
      {children}
    </label>
  );
}
